import React from "react";
import { useDispatch } from "react-redux";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { FullAgencyDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { openDrawer } from "@src/store/slices/drawers";

import { AgencySubscriptionPanel } from "./AgencySubscriptionPanel/AgencySubscriptionPanel";

interface CustomersTabProps {
  agency: FullAgencyDto;
}
export const SubscriptionsTab = ({ agency }: CustomersTabProps) => {
  const dispatch = useDispatch();

  if (!agency.customers.length) {
    return (
      <Grid
        container
        item
        direction={"column"}
        sx={{ padding: "15px" }}
        rowSpacing={1}
      >
        <Grid item textAlign={{ textAlign: "center" }}>
          <IgTypography variant={"body2"}>
            Assign a customer to this Agency to see its subscriptions.
          </IgTypography>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid
      container
      item
      direction={"column"}
      sx={{ padding: "15px" }}
      rowSpacing={2}
    >
      {agency.subscriptions.length ? (
        agency.subscriptions.map((subscription) => (
          <Grid item key={subscription.stripeSubscriptionId}>
            <AgencySubscriptionPanel
              subscription={subscription}
              agency={agency}
            />
          </Grid>
        ))
      ) : (
        <Grid item textAlign={{ textAlign: "center" }}>
          <IgTypography variant={"body2"}>
            {agency.organizationAgencyLinks?.length
              ? "Create a subscription to get started."
              : "Add an organization to this agency to get started."}
          </IgTypography>
        </Grid>
      )}
      <Grid item textAlign={"end"}>
        <IgButton
          disabled={!agency.organizationAgencyLinks.length}
          variant={"contained"}
          onClick={() => {
            dispatch(
              openDrawer({
                type: "createSubscription",
                orgs: agency.organizationAgencyLinks.map((oal) => ({
                  id: oal.organization.id,
                  shopId: oal.organization.shopId,
                })),
                agencyId: agency.id,
                usages: null,
              })
            );
          }}
        >
          Create Subscription
        </IgButton>
      </Grid>
    </Grid>
  );
};
